import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import '../components/AdminLayout.css';

function fmtDate(d) { return d ? new Date(d).toLocaleDateString('tr-TR') : '-'; }

const EMPTY_FORM = { faculty: '', department: '', term: '', course_name: '', group_title: '', is_active: true };

export default function CourseOptions() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterFaculty, setFilterFaculty] = useState('');
  const [filterDept, setFilterDept] = useState('');
  const [filterActive, setFilterActive] = useState('');
  const [faculties, setFaculties] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [actionLoading, setActionLoading] = useState(false);
  const [confirmDeactivate, setConfirmDeactivate] = useState(null);

  useEffect(() => { fetchCourses(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchCourses() {
    setLoading(true);
    const { data, error } = await supabase
      .from('course_options')
      .select('*')
      .order('created_at', { ascending: false });

    if (!error && data) {
      let filtered = data;
      if (filterFaculty) filtered = filtered.filter(c => c.faculty === filterFaculty);
      if (filterDept) filtered = filtered.filter(c => c.department === filterDept);
      if (filterActive === 'active') filtered = filtered.filter(c => c.is_active);
      if (filterActive === 'inactive') filtered = filtered.filter(c => !c.is_active);
      if (search) filtered = filtered.filter(c => (c.course_name || '').toLowerCase().includes(search.toLowerCase()));
      setCourses(filtered);

      const facs = [...new Set(data.map(c => c.faculty).filter(Boolean))];
      const depts = [...new Set(data.map(c => c.department).filter(Boolean))];
      setFaculties(facs);
      setDepartments(depts);
    }
    setLoading(false);
  }

  function openAdd() {
    setForm(EMPTY_FORM);
    setModal('add');
  }

  function openEdit(course) {
    setForm({ faculty: course.faculty || '', department: course.department || '', term: course.term || '', course_name: course.course_name || '', group_title: course.group_title || '', is_active: course.is_active ?? true, id: course.id });
    setModal('edit');
  }

  async function handleSave() {
    setActionLoading(true);
    if (modal === 'add') {
      await supabase.from('course_options').insert([{ faculty: form.faculty, department: form.department, term: form.term, course_name: form.course_name, group_title: form.group_title, is_active: form.is_active }]);
    } else {
      await supabase.from('course_options').update({ faculty: form.faculty, department: form.department, term: form.term, course_name: form.course_name, group_title: form.group_title, is_active: form.is_active }).eq('id', form.id);
    }
    setActionLoading(false);
    setModal(null);
    fetchCourses();
  }

  async function handleToggleActive(course) {
    setActionLoading(true);
    await supabase.from('course_options').update({ is_active: !course.is_active }).eq('id', course.id);
    setActionLoading(false);
    setConfirmDeactivate(null);
    fetchCourses();
  }

  return (
    <div>
      <div className="admin-filter-bar">
        <input className="admin-search-input" placeholder="Ders adı ile ara..." value={search} onChange={e => setSearch(e.target.value)} />
        <select className="admin-select" value={filterFaculty} onChange={e => setFilterFaculty(e.target.value)}>
          <option value="">Tüm Fakülteler</option>
          {faculties.map(f => <option key={f} value={f}>{f}</option>)}
        </select>
        <select className="admin-select" value={filterDept} onChange={e => setFilterDept(e.target.value)}>
          <option value="">Tüm Bölümler</option>
          {departments.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
        <select className="admin-select" value={filterActive} onChange={e => setFilterActive(e.target.value)}>
          <option value="">Tüm Durumlar</option>
          <option value="active">Aktif</option>
          <option value="inactive">Pasif</option>
        </select>
        <button className="btn-admin btn-admin-primary" onClick={fetchCourses}>Filtrele</button>
        <button className="btn-admin btn-admin-primary" style={{ marginLeft: 'auto', background: '#FFB400' }} onClick={openAdd}>+ Yeni Ekle</button>
      </div>

      <div className="admin-table-wrapper">
        <div className="admin-table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Fakülte</th>
                <th>Bölüm</th>
                <th>Dönem</th>
                <th>Ders Adı</th>
                <th>Grup</th>
                <th>Durum</th>
                <th>Eklenme</th>
                <th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr className="admin-loading-row"><td colSpan={8}>Yükleniyor...</td></tr>
              ) : courses.length === 0 ? (
                <tr className="admin-loading-row"><td colSpan={8}>Ders seçeneği bulunamadı.</td></tr>
              ) : courses.map(c => (
                <tr key={c.id}>
                  <td>{c.faculty || '-'}</td>
                  <td>{c.department || '-'}</td>
                  <td>{c.term || '-'}</td>
                  <td><strong>{c.course_name || '-'}</strong></td>
                  <td>{c.group_title || '-'}</td>
                  <td>{c.is_active ? <span className="badge badge-green">Aktif</span> : <span className="badge badge-gray">Pasif</span>}</td>
                  <td>{fmtDate(c.created_at)}</td>
                  <td style={{ display: 'flex', gap: 6 }}>
                    <button className="btn-admin btn-admin-outline" onClick={() => openEdit(c)}>Düzenle</button>
                    <button
                      className={`btn-admin ${c.is_active ? 'btn-admin-danger' : 'btn-admin-success'}`}
                      onClick={() => c.is_active ? setConfirmDeactivate(c) : handleToggleActive(c)}
                      disabled={actionLoading}
                    >
                      {c.is_active ? 'Pasifleştir' : 'Aktifleştir'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="admin-table-footer">Toplam {courses.length} ders seçeneği gösteriliyor</div>
      </div>

      {/* Add/Edit Modal */}
      {modal && (
        <div className="admin-modal-overlay">
          <div className="admin-modal" style={{ maxWidth: 520 }}>
            <h3>{modal === 'add' ? 'Yeni Ders Seçeneği Ekle' : 'Ders Seçeneğini Düzenle'}</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
              {[
                { key: 'faculty', label: 'Fakülte' },
                { key: 'department', label: 'Bölüm' },
                { key: 'term', label: 'Dönem' },
                { key: 'course_name', label: 'Ders Adı' },
                { key: 'group_title', label: 'Grup Başlığı' },
              ].map(f => (
                <div key={f.key} className="afield" style={{ gridColumn: f.key === 'course_name' ? '1 / -1' : undefined }}>
                  <label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#3D4F7C', marginBottom: 4, display: 'block' }}>{f.label}</label>
                  <input
                    style={{ padding: '9px 12px', border: '1.5px solid #E0E6F7', borderRadius: 8, fontSize: '0.875rem', fontFamily: 'inherit', outline: 'none', width: '100%' }}
                    value={form[f.key]}
                    onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                  />
                </div>
              ))}
              <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: 10 }}>
                <input type="checkbox" id="is_active" checked={form.is_active} onChange={e => setForm(prev => ({ ...prev, is_active: e.target.checked }))} />
                <label htmlFor="is_active" style={{ fontSize: '0.875rem', color: '#3D4F7C', fontWeight: 500 }}>Aktif</label>
              </div>
            </div>
            <div className="admin-modal-actions">
              <button className="btn-admin btn-admin-outline" onClick={() => setModal(null)}>İptal</button>
              <button className="btn-admin btn-admin-primary" onClick={handleSave} disabled={actionLoading || !form.course_name.trim()}>
                {actionLoading ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm deactivate */}
      {confirmDeactivate && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <h3>Dersi Pasifleştir</h3>
            <p><strong>{confirmDeactivate.course_name}</strong> dersi pasifleştirilecek. Devam etmek istiyor musunuz?</p>
            <div className="admin-modal-actions">
              <button className="btn-admin btn-admin-outline" onClick={() => setConfirmDeactivate(null)}>İptal</button>
              <button className="btn-admin btn-admin-danger" onClick={() => handleToggleActive(confirmDeactivate)} disabled={actionLoading}>
                {actionLoading ? 'İşleniyor...' : 'Pasifleştir'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
